import { useState, useEffect, useCallback, useMemo } from 'react';
import _cloneDeep from 'lodash/cloneDeep';
import _merge from 'lodash/merge';
import _isEqual from 'lodash/isEqual';
import { useDispatch, useSelector } from 'react-redux';
import { resetCalculations } from '../../../redux/actions/quickCalculationAction';
import { getCashbox } from '../../../redux/actions/handbookAction';
import { dealTypes, generateDealFormTabs } from '../../../helpers/data-constants';
import { defaultFormState } from './constants';

function useContractForm({ formState, defaultPurities, defaultThings, defaultCars, setFormState }) {
  const dispatch = useDispatch();
  const {cashbox} = useSelector(({handbook}) => handbook);
  const [showAnnuityAuto, setShowAnnuityAuto] = useState(false);
  const {accessFeatures}= useSelector(({user}) => user);
  const isHybrid = accessFeatures['deal.annuity.hybrid']

  const dealFormTabs = useMemo(() => generateDealFormTabs(showAnnuityAuto, isHybrid), [showAnnuityAuto]);

  const [currentDealTypeKey, setCurrentDealTypeKey] = useState(formState?.dealForm || dealTypes.SHORT_TERM.dealForm);
  const currentDealType = dealTypes[currentDealTypeKey];
  const activeDealTypeIndex = dealFormTabs.findIndex(tab => tab.dealForm === currentDealType.dealForm);

  useEffect(() => {
    if (!currentDealType) return;
    setFormState(prev => ({
      ...prev,
      typeContractTab: currentDealType.couponType,
      dealForm: currentDealType.dealForm,
    }));
  }, [currentDealType]);

  useEffect(() => {
    const isCarTab = formState.typeTab === 2;
    setShowAnnuityAuto(isCarTab);
  
    if (isCarTab) {
      if (currentDealTypeKey !== dealTypes.SHORT_TERM.dealForm) {
        setCurrentDealTypeKey(dealTypes.ANNUITY_DELAYED_START.dealForm);
      }
      if (cashbox?.id) {
        dispatch(getCashbox({
          id: cashbox.id,
          active: true,
          type: dealTypes[currentDealTypeKey]?.couponType,
        }));
      }
    } else {
      if (currentDealTypeKey === dealTypes.ANNUITY_DELAYED_START.dealForm) {
        setCurrentDealTypeKey(dealTypes.ANNUITY_CLASSIC.dealForm);
      }
    }
  }, [formState.typeTab, currentDealTypeKey]);

  const handleTypeTabSelect = useCallback(
    index => {
      setFormState(prev => ({
        ...prev,
        typeTab: index,
        purities: _cloneDeep(defaultPurities),
        things: { ...defaultThings },
        cars: _cloneDeep(defaultCars),
        calculation: {},
      }));
      dispatch(resetCalculations());
    },
    [dispatch],
  );

  const handleDealTypeTabSelect = useCallback(index => {
        setCurrentDealTypeKey(dealFormTabs[index].dealForm);
        if(cashbox?.id) {
            dispatch(getCashbox({id: cashbox.id, active: true, type: dealFormTabs[index].couponType}))
        }
        setFormState((prev) => ({...prev, calculation: {
          ...defaultFormState.calculation,
          amount: prev.calculation?.amount,
        } }));
        dispatch(resetCalculations());
        },
    [cashbox, dispatch, dealFormTabs, setFormState],
  );

  return {
    showAnnuityAuto,
    currentDealTypeKey,
    dealFormTabs,
    activeDealTypeIndex,
    setShowAnnuityAuto,
    handleTypeTabSelect,
    handleDealTypeTabSelect,
  };
}

export default useContractForm;
